import { render } from "./MunicipioBusinesses.vue?vue&type=template&id=4b160140"
import script from "./MunicipioBusinesses.vue?vue&type=script&lang=js"
export * from "./MunicipioBusinesses.vue?vue&type=script&lang=js"

import "./MunicipioBusinesses.vue?vue&type=style&index=0&id=4b160140&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__